import React from 'react'

export default function HeaderSocials() {
  return (
    <div className="home_socials">
        <a href="https://github.com/fahadkabali" className="home_social-link" target="_blank" rel="noopener noreferrer">
            <i class="fa-brands fa-github"></i>
        </a>
        <a href="https://www.linkedin.com/in/kabali-fahad-maliki/" className="home_social-link" target="_blank" rel="noopener noreferrer">
            <i class="fa-brands fa-linkedin"></i>
        </a>
        <a href="https://twitter.com/fahd_kf_" className="home_social-link" target="_blank" rel="noopener noreferrer">
            <i class="fa-brands fa-x-twitter"></i>
        </a>
        <a href="https://www.instagram.com/fahd_kf_/" className="home_social-link" target="_blank" rel="noopener noreferrer">
            <i class="fa-brands fa-instagram"></i>
        </a>
        <a href="https://www.facebook.com/" className="home_social-link" target="_blank" rel="noopener noreferrer">
            <i class="fa-brands fa-facebook"></i>
        </a>
        <a href="https://www.tiktok.com/" className="home_social-link" target="_blank" rel="noopener noreferrer">
            <i class="fa-brands fa-tiktok"></i>
        </a>
        
    </div>
  )
}
